import React, {Component} from 'react';

class Breakfast extends Component {
    render() {
        return (
            <div id="3" data-id="3" className="swiper-slide">
                <div className={"side_image side_image-3"}/>
                <div className="breakfast-page page">
                    <div className="breakfast__content page__content visible-content">
                        <h2>Speisekarte (Frühstück)</h2>
                        <p className="closed-notice">Vorübergehend geschlossen</p>
                        <div className="page_description">
                            <p>Breakfast menu</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Breakfast;
